// 크리에이터의 캠페인 신청 상태
export const APPLIED_STATUS = {
  pending: { label: "검토 중", className: "bg-[#e3f2fd] text-[#1976d2]" },
  accepted: { label: "승인", className: "bg-[#e8f5e9] text-[#2e7d32]" },
  confirmed: {
    label: "원고 제출 승인",
    className: "bg-[#e8f5e9] text-[#2e7d32]",
  },
  rejected: { label: "거절", className: "bg-[#ffebee] text-[#c62828]" },
  cancelled: { label: "취소", className: "bg-[#fff3e0] text-[#e65100]" },
  completed: {
    label: "최종 승인 완료",
    className: "bg-[#f3e5f5] text-[#7b1fa2]",
  },
  paid: {
    label: "브랜드 정산 완료",
    className: "bg-[#f3e5f5] text-[#7b1fa2]",
  },
  default: {
    label: "알 수 없음",
    className: "bg-[#f5f5f5] text-[#616161]",
  },
};

// 원고/포스팅 검토 상태
export const POSTING_REVIEW = {
  paid: { label: "승인 완료", className: "text-[#2e7d32]" },
  confirmed: { label: "승인 완료", className: "text-[#2e7d32]" },
  completed: { label: "완료", className: "text-[#1b5e20]" },
  rejected: { label: "반려", className: "text-[#c62828]" },
  default: { label: "검토 중", className: "text-[#1976d2]" },
};

// 브랜드의 캠페인 신청자 관리
export const BRAND_STATUS = {
  pending: {
    label: "검토 중",
    backgroundColor: "#e3f2fd",
    color: "#1976d2",
  },
  accepted: {
    label: "신청승인",
    backgroundColor: "#e8f5e9",
    color: "#2e7d32",
  },
  confirmed: {
    label: "원고 승인",
    backgroundColor: "#e8f5e9",
    color: "#2e7d32",
  },
  rejected: {
    label: "신청거절",
    backgroundColor: "#ffebee",
    color: "#c62828",
  },
  completed: {
    label: "최종 승인 완료",
    backgroundColor: "#f3e5f5",
    color: "#7b1fa2",
  },
  cancelled: {
    label: "취소",
    backgroundColor: "#f5f5f5",
    color: "#757575",
  },
  paid: {
    label: "정산 완료",
    backgroundColor: "#f3e5f5",
    color: "#7b1fa2",
  },
  default: {
    label: "알 수 없음",
    backgroundColor: "#f5f5f5",
    color: "#616161",
  },
};

// 에이전시 캠페인 관리
export const AGENCY_STATUS = {
  pending: { label: "검토 중", className: "bg-[#e3f2fd] text-[#1976d2]" },
  accepted: { label: "승인", className: "bg-[#e8f5e9] text-[#2e7d32]" },
  confirmed: { label: "원고 승인", className: "bg-[#e8f5e9] text-[#2e7d32]" },
  completed: {
    label: "최종 승인 완료",
    className: "bg-[#f3e5f5] text-[#7b1fa2]",
  },
  paid: {
    label: "브랜드 정산 완료",
    className: "bg-[#f3e5f5] text-[#7b1fa2]",
  },
  rejected: { label: "반려", className: "bg-[#ffebee] text-[#c62828]" },
  cancelled: { label: "취소", className: "bg-[#f5f5f5] text-[#616161]" },
  invited: { label: "초대됨", className: "bg-[#f3e5f5] text-[#7b1fa2]" },
  default: { label: "알 수 없음", className: "bg-[#f5f5f5] text-[#616161]" },
};

// 캠페인 카드의 캠페인 진행 상태
const INFLUENCER_PROGRESS = {
  pending: { label: "검토 중", className: "text-[#1976d2]" },
  accepted: { label: "승인", className: "text-[#2e7d32]" },
  confirmed: { label: "원고 제출 승인", className: "text-[#2e7d32]" },
  rejected: { label: "거절", className: "text-[#c62828]" },
  cancelled: { label: "취소", className: "text-[#e65100]" },
  completed: { label: "완료", className: "text-[#1b5e20]" },
  paid: { label: "정산 완료", className: "text-[#7b1fa2]" },
  default: { label: "알 수 없음", className: "text-[#006fdf]" },
};

export const getMyProgress = (campaign) => {
  if (campaign?.invitation_status === "invited") {
    return { text: "초대됨", className: "text-[#006fdf]" };
  }
  const status = campaign?.recruitment_status;
  const info = INFLUENCER_PROGRESS[status] ?? INFLUENCER_PROGRESS.default;
  return { text: info.label, className: info.className };
};
